import React, { useState } from 'react';
import SeoDatoCMS from '../../Layout/SeoDatocms';
import Layout from '../../Layout/Layout';
import axios from 'axios';
import { navigate } from 'gatsby';

import './index.scss';

const ProtectedView = ({ page, context, favicon }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [msgError, setMsgError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setMsgError(null);

    axios
      .post('/api/protected-system', { email, password })
      .then((response) => {
        if (response.data.success) {
          sessionStorage.setItem(`protectedPage_${page.id}`, 'true');
          navigate('/' + context.slug);
        } else {
          setMsgError(response.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
        setMsgError(error.response?.data.msg);
      });
  };

  return (
    <Layout>
      <SeoDatoCMS seo={page.seo} favicon={favicon} />
      <div className="protected-view">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>This page is protected</h1>
              <p className="info">
                This page requires a password to be access. If you need a password, please contact Dimo Ortiz at{' '}
                <a href="mailto:dimo@onepa.org">dimo@onepa.org</a>
              </p>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  Access
                </button>
              </form>

              {msgError && <p className="error">{msgError}</p>}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProtectedView;
